import { useState } from 'react';
import { BuildingType, DataType } from './OverviewReport.types';

export enum ActivePropertiesDataType {
  PORTFOLIO_TOTAL = 'Portfolio total',
  MARKET_TOTAL = 'Market total',
}

export const useOverviewFilters = () => {
  const [prospectsBuildingType, setProspectsBuildingType] = useState<BuildingType>(BuildingType.MULTIFAMILY);
  const [prospectsDisplayType, setProspectsDisplayType] = useState<DataType>(DataType.PORTFOLIO_TOTAL);

  const [pageViewsBuildingType, setPageViewsBuildingType] = useState<BuildingType>(BuildingType.MULTIFAMILY);
  const [pageViewsDisplayType, setPageViewsDisplayType] = useState<DataType>(DataType.PORTFOLIO_TOTAL);

  const [impressionsBuildingType, setImpressionsBuildingType] = useState<BuildingType>(BuildingType.MULTIFAMILY);
  const [impressionsDisplayType, setImpressionsDisplayType] = useState<DataType>(DataType.PORTFOLIO_TOTAL);

  const [activePropertiesBuildingType, setActivePropertiesBuildingType] = useState<BuildingType>(
    BuildingType.MULTIFAMILY,
  );
  const [activePropertiesDisplayType, setActivePropertiesDisplayType] = useState<ActivePropertiesDataType>(
    ActivePropertiesDataType.PORTFOLIO_TOTAL,
  );

  return {
    prospectsBuildingType,
    setProspectsBuildingType,
    prospectsDisplayType,
    setProspectsDisplayType,
    pageViewsBuildingType,
    setPageViewsBuildingType,
    pageViewsDisplayType,
    setPageViewsDisplayType,
    impressionsBuildingType,
    setImpressionsBuildingType,
    impressionsDisplayType,
    setImpressionsDisplayType,
    activePropertiesBuildingType,
    setActivePropertiesBuildingType,
    activePropertiesDisplayType,
    setActivePropertiesDisplayType,
  };
};
